import { defineComponent } from "vue";

export default defineComponent({
  setup() {
    return () => <div class="building">building</div>;
  },
});
